/**
 * Số chứng từ tự tăng
 */
export default {
  BUPlanWithdrawAdjustment: 31, //Điều chỉnh tạm ứng
  BURealAdjustment: 70, //Điều chỉnh thực chi
};
